import { render, staticRenderFns } from "./RsaGestioneOspitePrescrizioniListComponent.vue?vue&type=template&id=5450acc2&scoped=true"
import script from "./RsaGestioneOspitePrescrizioniListComponent.vue?vue&type=script&lang=js"
export * from "./RsaGestioneOspitePrescrizioniListComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaGestioneOspitePrescrizioniListComponent.vue?vue&type=style&index=0&id=5450acc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5450acc2",
  null
  
)

export default component.exports